import 'bootstrap';
import './flipclock.js';
import lightyear from './lightyear.js';

const iconboxButtons = document.querySelectorAll('.why .iconbox');
const videoDots = document.querySelectorAll('.why .video-dots__point');
let interval = null;

if (iconboxButtons.length > 0) {
  iconboxButtons.forEach((btn, index) => {
    btn.addEventListener('click', (e) => {
      initVideo(e, index);
      autoSwipeVideo(e, index);
      addIconboxActiveClass(e, index);
      checkActiveDotsPoint(e, index);
      toggleMobileVideoPopup(e);
    });
  });
}

if (videoDots.length > 0) {
  videoDots.forEach((btn, index) => {
    btn.addEventListener('click', (e) => {
      initVideo(e, index);
      autoSwipeVideo(e, index);
      addIconboxActiveClass(e, index);
      checkActiveDotsPoint(e, index);
    });
  });
}

function initVideo(e, index) {
  const videoContainer = document.querySelector('.video-container');

  videoContainer.innerHTML = '';
  videoContainer.insertAdjacentHTML(
    'afterbegin',
    `
      <button class="close-popup-btn"><img src="/с/blackfridaypromo/img/close.svg" alt=""></button>
			<video width="100%" muted autoplay>
        <source src="/с/blackfridaypromo/uploads/${index}.mp4" type="video/mp4">
      </video>
		`
  );
}

function autoSwipeVideo(e, index) {
  window.clearInterval(interval);

  let count = index;
  const videoContainer = document.querySelector('.video-container');

  interval = setInterval(() => {
    count++;

    if (count >= iconboxButtons.length) {
      count = 0;
    }

    videoContainer.innerHTML = '';
    videoContainer.insertAdjacentHTML(
      'afterbegin',
      `
        <button class="close-popup-btn"><img src="/с/blackfridaypromo/img/close.svg" alt=""></button>
				<video width="100%" muted autoplay>
					<source src="/с/blackfridaypromo/uploads/${count}.mp4" type="video/mp4">
				</video>
			`
    );

    addIconboxActiveClass(e, count);
    checkActiveDotsPoint(e, count);
  }, 10000);
}

function addIconboxActiveClass(e, count) {
  const currentActiveIconbox = document.querySelector('.iconbox--active');

  if (currentActiveIconbox) {
    currentActiveIconbox.className = 'iconbox';
  }

  if (count >= 0) {
    iconboxButtons[count].classList.add('iconbox--active');
  } else {
    e.target.closest('.iconbox').classList.add('iconbox--active');
  }
}

function checkActiveDotsPoint(e, count) {
  const currentPoint = document.querySelector('.video-dots__point--active');

  if (currentPoint) {
    currentPoint.className = 'video-dots__point';
  }

  if (count >= 0) {
    videoDots[count].classList.add('video-dots__point--active');
  } else {
    e.target.classList.add('video-dots__point--active');
  }
}

function autoCheckVideo() {
  const currentScrollPosition = window.pageYOffset;
  const elementOffsetTop = document
    .querySelector('.why')
    .getBoundingClientRect().top;

  if (currentScrollPosition >= elementOffsetTop) {
    iconboxButtons[0].click();
    window.removeEventListener('scroll', autoCheckVideo);
  }
}

if(window.innerWidth > 768) {
  window.addEventListener('scroll', autoCheckVideo);
}

/* MOBILE-MENU */

const mobileBtn = document.querySelector('.mobile-menu-btn');
const closeBtn = document.querySelector('.close-btn');

mobileBtn.addEventListener('click', (e) => {
  const navbar = document.querySelector('.header-mobile .navbar-nav');
  navbar.classList.toggle('opened');
});

closeBtn.addEventListener('click', (e) => {
  const navbar = document.querySelector('.header-mobile .navbar-nav');
  navbar.classList.toggle('opened');
});

/* TRACKING */

const trackButtons = document.querySelectorAll('.track-btn');

trackButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    lightyear.track('view_landing_page');
  });
});

/* MODAL VIDEO */

function toggleMobileVideoPopup(e) {
  if (window.innerWidth < 768) {
    const videoContainer = document.querySelector('.video-container');
    videoContainer.classList.toggle('opened');
  }
}

if (window.innerWidth < 768) {
  document.addEventListener('click', (e) => {
    if (e.target.closest('button').className === 'close-popup-btn') {
      toggleMobileVideoPopup(e);
    }
  });
}
lightyear.track('view_landing_page')
